export default __webpack_public_path__ + "static/media/create-category-img-homepage.bc183061.png";